import { sheets } from '@/app/grid/controller/Sheets';
import { tableInfoAtom } from '@/app/atoms/tableInfoAtom';
import type { PromptEditorMention } from '@/app/ui/components/promptEditor/PromptEditor';
import { getDefaultStore } from 'jotai';

/**
 * Classify a grid reference string (a table/code name, a sheet name, or an A1
 * range like `Sheet1!A1:B5`) into the matching inline mention so the "Reference
 * in chat" action can insert a pill instead of raw `@text`.
 *
 * Falls back to the `cell` kind for arbitrary ranges that don't resolve to a
 * named table or sheet.
 */
export function resolveGridReferenceMention(reference: string): PromptEditorMention {
  const base: PromptEditorMention = { id: reference, label: reference, kind: 'cell' };

  const trimmed = reference.trim();
  if (!trimmed) return base;

  const tableInfo = getDefaultStore().get(tableInfoAtom);
  const table = tableInfo.find((info) => info.name === trimmed);
  if (table) {
    return { ...base, kind: table.language === 'Import' ? 'table' : 'code' };
  }

  const sheet = sheets.map((s) => s).find((s) => s.name === trimmed);
  if (sheet) {
    // Sheet pills navigate by id, so the mention id must be the sheet id.
    return { ...base, id: sheet.id, kind: 'sheet' };
  }

  return base;
}
